export const proxyConfig = {
  'zhaixing': {
    favIcon: 'https://dev.cdn-pub.zxaigc.com/public/68cee801754c90d5dcc1.png',
    Logo: 'https://dev.cdn-pub.zxaigc.com/public/7d5bff5d0927e5408dab.png',
    Background: 'https://dev.cdn-pub.zxaigc.com/public/87d164069bd1325566de.png',
    FavTitle: '摘星方舟',
    filing: '皖ICP备2024062962号-1',
  },
  'yunshi': {
    favIcon: 'https://zhaixing-prod-00.oss-cn-shanghai.aliyuncs.com/public/ccd127c08f3967fe90e53ba45103d74b%402x%20(1).png',
    Logo: 'https://zhaixing-prod-00.oss-cn-shanghai.aliyuncs.com/public/4098f846ad523ea00cc4394140073e3.png',
    Background: 'https://zhaixing-prod-00.oss-cn-shanghai.aliyuncs.com/public/95011.png',
    FavTitle: '云视获客',
    filing: '皖ICP备2024062962号-1',
  },
  '51wl': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/3.png',
    FavTitle: '搜索排名',
    filing: '皖ICP备18001927号-16',
  },
  'fengyin': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/3.png',
    FavTitle: '云视搜索',
    filing: '蜀ICP备2024055338号-1'
  },
  'juyuai': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/3.png',
    FavTitle: '巨宇AI获客',
    filing: '浙ICP备12013743号-16'
  },
  'qiteng518': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/3.png',
    FavTitle: '剪辑系统',
    filing: '津ICP备2022003066号-6'
  },
  'tui55': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/3.png',
    FavTitle: '千里马AI获客',
    filing: '渝ICP备13002463号-18'
  },
  'pbinfo': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/3.png',
    FavTitle: '鹏博资讯',
    filing: '粤ICP备11039585号-5'
  },
}